/* Adams Athletics — theme.js */
(function () {
  'use strict';

  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v);
  };

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nav-toggle]');
    if (!b) return;
    var nav = document.querySelector('[data-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* ---------- Gallery ---------- */
  function Gallery(root) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var i = 0;

    function go(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var active = thumbs[i];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1);
      if (e.key === 'ArrowRight') go(i + 1);
    });

    // Jump to the media index for a selected variant
    root.addEventListener('gallery:show', function (e) {
      var idx = parseInt(e.detail, 10);
      if (!isNaN(idx) && idx >= 0) go(idx);
    });

    go(0);
  }
  document.querySelectorAll('[data-gallery]').forEach(Gallery);

  /* ---------- Product form ---------- */
  function Product(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var fmt = dataEl.dataset.format || '${{amount}}';
    var idInput = root.querySelector('[data-variant-id]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceOff = root.querySelector('[data-price-off]');
    var finance = root.querySelector('[data-finance]');
    var totalOut = root.querySelector('[data-total]');
    var stockOut = root.querySelector('[data-stock]');
    var stockPip = root.querySelector('[data-stock-pip]');
    var qtyInput = root.querySelector('[data-qty]');
    var gallery = document.querySelector('[data-gallery]');
    var lowAt = parseInt(root.dataset.lowStock || '8', 10);
    var months = parseInt(root.dataset.financeMonths || '12', 10);
    var current = variants[0];

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10) || 1); }

    function render() {
      if (!current) return;
      if (idInput) idInput.value = current.id;

      if (priceNow) priceNow.textContent = money(current.price, fmt);
      var onSale = current.compare_at_price && current.compare_at_price > current.price;
      if (priceWas) {
        priceWas.textContent = onSale ? money(current.compare_at_price, fmt) : '';
        priceWas.style.display = onSale ? '' : 'none';
      }
      if (priceOff) {
        if (onSale) {
          priceOff.textContent = Math.round((1 - current.price / current.compare_at_price) * 100) + '% Off';
          priceOff.style.display = '';
        } else { priceOff.style.display = 'none'; }
      }
      if (finance) finance.innerHTML = 'Or <b>' + money(Math.ceil(current.price / months), fmt) + '/mo</b> with Shop Pay Installments';

      if (totalOut) totalOut.textContent = money(current.price * qty(), fmt);

      if (stockOut) {
        var q = current.inventory_quantity;
        var tracked = current.inventory_management && current.inventory_policy !== 'continue';
        if (!current.available) {
          stockOut.textContent = root.dataset.stockMsgOut || 'Sold out';
        } else if (tracked && typeof q === 'number' && q > 0 && q <= lowAt) {
          stockOut.textContent = (root.dataset.stockMsgLow || 'Only {n} left').replace('{n}', q);
        } else {
          stockOut.textContent = root.dataset.stockMsg || 'In stock';
        }
        if (stockPip) stockPip.classList.toggle('stock__pip--low', !!(tracked && typeof q === 'number' && q <= lowAt));
      }

      if (atc) {
        atc.disabled = !current.available;
        if (atcLabel) atcLabel.textContent = current.available ? (atc.dataset.label || 'Add to cart') : 'Sold out';
      }

      opts.forEach(function (o) { o.setAttribute('aria-pressed', String(o.dataset.opt === String(current.id))); });

      var st = document.querySelector('[data-sticky-price]');
      if (st) st.textContent = money(current.price * qty(), fmt);

      if (gallery && current.featured_media_index !== '' && current.featured_media_index != null) {
        gallery.dispatchEvent(new CustomEvent('gallery:show', { detail: current.featured_media_index }));
      }
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        var v = variants.filter(function (x) { return String(x.id) === o.dataset.opt; })[0];
        if (v) { current = v; render(); }
      });
    });

    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = qty() + parseInt(b.dataset.qtyStep, 10);
        qtyInput.value = Math.max(1, next);
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', render);

    /* Purchase mode toggle (one-time vs subscribe/selling plan) */
    var planInput = root.querySelector('[data-selling-plan]');
    root.querySelectorAll('[data-mode]').forEach(function (m) {
      m.addEventListener('click', function () {
        root.querySelectorAll('[data-mode]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        m.setAttribute('aria-pressed', 'true');
        if (planInput) planInput.value = m.dataset.mode === 'plan' ? (m.dataset.planId || '') : '';
        root.querySelectorAll('[data-mode-note]').forEach(function (n) {
          n.hidden = n.dataset.modeNote !== m.dataset.mode;
        });
      });
    });

    /* Sticky bar mirrors the real submit */
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = root.querySelector('form[action*="/cart/add"]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    render();
  }
  document.querySelectorAll('[data-product]').forEach(Product);

  /* ---------- Sticky ATC visibility ---------- */
  var bar = document.querySelector('[data-sticky]');
  var anchor = document.querySelector('[data-sticky-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(anchor);
  }
})();
